/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Userskills1Inputs */

const en_entity_userskills1 = /** @type {(inputs: Entity_Userskills1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Skills`)
};

const de_entity_userskills1 = /** @type {(inputs: Entity_Userskills1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer-Skills`)
};

/**
* | output |
* | --- |
* | "User Skills" |
*
* @param {Entity_Userskills1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_userskills1 = /** @type {((inputs?: Entity_Userskills1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Userskills1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_userskills1(inputs)
	return de_entity_userskills1(inputs)
});
export { entity_userskills1 as "entity_userSkills" }